import React from 'react'
import {message,Tooltip} from 'antd'
import Color from './Color'

export default class ColorBox extends React.Component {
  state={}
  componentDidMount() {
    const {value} = this.props
    if (typeof(value)==='object'&&value!==null) {
      this.setState({
        name: value.name,
        value: new Color(value.value),
      })
    }
  }
  static getDerivedStateFromProps(props,state) {
    const {value} = props
    if (typeof(value)==='object'&&value!==null) {
      return {
        name: value.name,
        value: new Color(value.value),
      }
    }
    return null
  }
  copyToClipboard=event=>{
    event.preventDefault()
    const {value,name} = this.state
    const {format,onCopy} = this.props
    if (value instanceof Color) {
      const el = document.createElement('textarea')
      const color = value.toString(format)
      el.value = color
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      message.success(`${name} is copied`)
      if (typeof(onCopy)==='function') {
        onCopy(value)
      }
    }
  }
  render() {
    const {name,value} = this.state
    if (value instanceof Color) {
      const {format,copied} = this.props
      const backgroundColor = value.toString()
      const lumin = value.luminance()
      const color = lumin.toString()
      const textShadow = `${lumin.luminance().toString('#')} 1px 0 5px`
      const title = value.isEqual(copied)?`\u2705 ${name} is copied`:`Copy ${name}`
      return (
        <Tooltip title={title}>
          <div className="box" style={{backgroundColor,color,textShadow}} onClick={this.copyToClipboard}>
            <div className="mb-2">{name}</div>
            <div className="color-value">{value.toString(format)}</div>
          </div>
        </Tooltip>
      )
    }
    return null
  }
}
